import type React from 'react';

interface CrownIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CrownIcon({ size = 24, ...props }: CrownIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3223 7.25694L7.8816 4.15886L4.44061 7.25691L2.28251 5.3137L3.49472 12.1877H12.2684L13.4805 5.31365L11.3223 7.25694ZM14.7629 3L12.991 13.0489H2.77209L1 3L4.44064 6.09805L7.88163 3L11.3223 6.09805L14.7629 3Z"
        fill="#FDBC42"
      />
      <path d="M13.194 11.8877H2.56396V13.0531H13.194V11.8877Z" fill="#FDBC42" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.194 11.8877V13.0531H2.56396V11.8877H13.194Z"
        fill="#FDBC42"
      />
    </svg>
  );
}
